import { useDialogState } from "../../../../hooks/useDialogState";
import { useField } from "../../../forms/Field";
import { Box, Button, Dialog, Typography } from "@mui/material";
import { T } from "../../../util/t";
import { FieldMessage } from "../../forms/FormField";
import { Check } from "@mui/icons-material";
import { SignatureDialogContent } from "./SignatureDialogContent";

export const SignatureField = ({ field, control, property, athlete, isSeriesRegistration }) => {
    const { input, fieldState } = useField({ field, control });
    const [dialogOpen, openDialog, closeDialog] = useDialogState();

    return (
        <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography sx={{ wordBreak: "break-all" }}>{property.label}</Typography>
            <section>
                {input.value ?
                    <Button sx={{ whiteSpace: "nowrap" }} startIcon={<Check/>} component="a" href={input.value} target="_blank" rel="noopener noreferrer">
                        <T>Signed</T>
                    </Button> :
                    <Button sx={{ whiteSpace: "nowrap" }} variant="outlined" onClick={openDialog}>
                        <T>View and sign</T>
                    </Button>
                }

                {!!fieldState.error &&
                <FieldMessage
                    isDirty={fieldState.isDirty}
                    errorMessage={fieldState.error.message}
                />}
            </section>

            <Dialog open={dialogOpen} onClose={closeDialog} fullScreen aria-labelledby="signature-dialog">
                <SignatureDialogContent
                    property={property}
                    athlete={athlete}
                    isSeriesRegistration={isSeriesRegistration}
                    closeDialog={closeDialog}
                    onChange={input.onChange}
                />
            </Dialog>
        </Box>
    );
};

